import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import StoreSubTypeForm, { StoreSubTypeFormData } from "../../../components/admin/storeSybTypes/StoreSubTypeForm";

export default function AdminAddStoreSubTypePage() {
  const navigate = useNavigate();
  const { typeId} = useParams<{ typeId: string}>();
  const numericTypeIdId = typeId ? parseInt(typeId) : 0;

  const { register, handleSubmit, formState: { errors } } = useForm<StoreSubTypeFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });


   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: StoreSubTypeFormData) => {
    const languages = data.languages.map((da)=>({name:da.title,languageCode:da.languageCode}));
    updateResource(`subtype/create`, {languages , typeId:numericTypeIdId},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["store-sub-types-by-admin"],
            navigateAfter: () => navigate(`/admin/subTypes/${numericTypeIdId}`),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_sub_type" />
        <StoreSubTypeForm register={register} errors={errors} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
